import React, { createContext, useContext, useEffect, useState } from 'react';
import { useFeatureFlagsClient } from './featureFlags.client';
// Create the context with a default value
const FeatureFlagContext = createContext(null);
export const FeatureFlagProvider = ({ children }) => {
    const featureFlagClient = useFeatureFlagsClient();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [featureFlags, setFeatureFlags] = useState([]);
    const fetchFeatureFlagData = async () => {
        try {
            setLoading(true);
            setError(null);
            // @TODO: FLU-193 Handle this. Finalize what error handler needs to be used here.
            const data = await featureFlagClient.listFeatureFlags();
            setFeatureFlags(data);
        }
        catch (err) {
            setError('Failed to load feature flag data. Please try again.');
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchFeatureFlagData();
    }, []);
    const contextValue = {
        loading,
        featureFlags,
        refreshFeatureFlags: fetchFeatureFlagData
    };
    return (React.createElement(FeatureFlagContext.Provider, { value: contextValue }, children));
};
// Custom hook to use the configService
export const useFeatureFlags = () => {
    const context = useContext(FeatureFlagContext);
    if (context === null) {
        return {
            loading: false,
            featureFlags: [],
            refreshFeatureFlags: async () => { }
        };
    }
    return context;
};
export const useFeatureFlag = (flagName) => {
    const { loading, featureFlags } = useFeatureFlags();
    const [enabled, setEnabled] = useState(false);
    useEffect(() => {
        let featureFlag = featureFlags?.find((f) => f.name === flagName);
        if (!featureFlag) {
            console.info(`Feature flag [${flagName}] not found, assuming it is disabled`);
        }
        setEnabled(featureFlag?.enabled ?? false);
    }, [featureFlags, flagName]);
    //We assume that the flag is disabled by default
    return { loading, enabled };
};
